import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class ShipmentData {
  /* 发货数据列表 */
  static getShipmentDataList(options) {
    let url = `/oa/api/delivery/data/project/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 仓库总计 */
  static getShipmentStatisticsListList(options) {
    let url = `/oa/api/delivery/data/warehouse/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 实际单量列表 */
  static getActualList(options) {
    let url = `/oa/api/delivery/data/receive/order/num/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改、保存 实际单量 */
  static saveActualOrderNums(data) {
    let url = `/oa/api/delivery/data/receive/order/num/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ShipmentData